import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { CommonStore } from '../stores/commonStore';
import appLogo from '../logo/Wellpoint.png';


@observer
class Header extends Component {

  render() {
    const { commonStore } = this.props;
    const {
      appName
    } = commonStore;
    return (
      <div>
        <div className="pb-spacer" />
        <div className="container pl-40">
          <img src={ appLogo } alt="appLogo" />
        </div>
        <section className="headerSection">
          <div className="container">
            <div className="headerDiv">
              <h2 className="headerText">
                <div className="pl-22">
                  <strong>{appName}</strong>
                </div>
              </h2>
            </div>
          </div>
        </section>
        <hr className="mtnbrem-3"/>
      </div>
    );
  }
}

export default Header;

Header.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore),
};
